'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ratingSpans(theme, actualScore, scale) {
    return (0, _from2.default)(new Array(scale), function (val, index) {
        return index + 1;
    }).map(function (rating) {
        var _classnames;

        var classes = (0, _classnames3.default)(theme.item, (_classnames = {}, (0, _defineProperty3.default)(_classnames, theme.highlight, rating <= actualScore), (0, _defineProperty3.default)(_classnames, theme.active, actualScore === rating), _classnames));
        var score = actualScore === rating ? rating : '';
        return _react2.default.createElement(
            'span',
            { key: rating, className: classes },
            score
        );
    });
}

var Grade = function Grade(_ref) {
    var theme = _ref.theme,
        grade = _ref.grade,
        scale = _ref.scale;

    var actualScore = Math.round(grade * scale);
    return _react2.default.createElement(
        'aside',
        { className: theme.root, 'data-test-tag': '@spp/ui-grade' },
        ratingSpans(theme, actualScore, scale)
    );
};

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/article/components.md#grade

Grade.propTypes = {
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string,
        item: _propTypes2.default.string,
        highlight: _propTypes2.default.string,
        active: _propTypes2.default.string
    }),
    grade: _propTypes2.default.number.isRequired,
    scale: _propTypes2.default.number
};

Grade.defaultProps = {
    scale: 6,
    theme: {}
};

exports.default = Grade;
//# sourceMappingURL=Grade.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-grade/lib/cjs/Grade.js
 ** module id = 517
 ** module chunks = 1
 **/